import { Controller } from '@hotwired/stimulus'
import { useResizeObserver } from "stimulus-library"

// Re-checks when the parent resizes, since that is what changes the space the text has.
export default class DetectTruncationController extends Controller {
  static classes = ['overflowing']

  connect() {
    super.connect()
    this.detect()
    useResizeObserver(this, this.element.parentElement, this.detect)
  }

  detect() {
    this.element.classList.toggle(this.overflowingClass, this.isTruncated())
  }

  isTruncated() {
    return this.horizontallyTruncated() || this.verticallyTruncated()
  }

  horizontallyTruncated() {
    return this.element.scrollWidth > this.element.clientWidth
  }

  verticallyTruncated() {
    return this.element.scrollHeight > this.element.clientHeight
  }
}
